import { FilterItem } from "~components/Filter"
import { PROOF_OF_OWNERSHIP_STATUS } from "~constants/proofOfOwnership"
import { POO_ASSIGNED_VIEW } from "~utils/pooAssignment"

// The operator's personal pipeline: pick up from Created, claim into My
// validations. Rendered as the main segmented control.
export const proofOfOwnershipPipelineFilters: FilterItem[] = [
  {
    value: PROOF_OF_OWNERSHIP_STATUS.CREATED,
    text: "Created",
  },
  {
    value: POO_ASSIGNED_VIEW,
    text: "My validations",
  },
]

// The org-wide oversight view: everything currently being validated by anyone.
// Rendered apart from the pipeline as its own tab.
export const proofOfOwnershipGlobalFilter: FilterItem = {
  value: PROOF_OF_OWNERSHIP_STATUS.VALIDATING,
  text: "All in validation",
}
